import styled from 'styled-components';

export default styled.div`
  position: relative;
  background-image: url(${props => props.src});
  background-color: rgba(0, 0, 0, 1);
  background-size: cover;
  width: 100%;
  height: 100vh;
  background-position: center center;
`;
